export function integrationsCatalogOverviewPage () {
  window.analytics.page('Integrations Catalog')
}

export function integrationsCatalogDetailPage () {
  window.analytics.page('Integrations Catalog Detail')
}

export function integrationsCatalogTileClick (workspace, integrationSlug) {
  window.analytics.track('Integrations Catalog Tile Click', {
    workspace_id: workspace.id,
    workspace_slug: workspace.slug,
    integration_slug: integrationSlug
  })
}

export function integrationsCatalogButtonClick (workspace, integrationSlug, button) {
  window.analytics.track('Integrations Catalog Button Click', {
    workspace_id: workspace.id,
    workspace_slug: workspace.slug,
    integration_slug: integrationSlug,
    button
  })
}

export function integrationsCatalogAddSourceClick (workspace, integrationSlug, popover) {
  window.analytics.track('Integrations Catalog Add Source Click', {
    workspace_id: workspace.id,
    workspace_slug: workspace.slug,
    integration_slug: integrationSlug,
    popover
  })
}

export function integrationsCatalogSourceClick (workspace, integrationSlug, source, popover) {
  window.analytics.track('Integrations Catalog Source Click', {
    workspace_id: workspace.id,
    workspace_slug: workspace.slug,
    integration_slug: integrationSlug,
    source_id: source.id,
    source_slug: source.slug,
    popover
  })
}



// WEBPACK FOOTER //
// ./analytics/integrations-catalog.js